import Joi from '@hapi/joi'

export const MasterCardLeafCollectionTagSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    factoryID: Joi.number().invalid(0).required().label("Factory").messages({
        "any.invalid": `Select Factory`,
        "any.required": `Factory required`
    }),
    routeID: Joi.number().allow("", null).label("Route"),
        
    toDate: Joi.string().invalid("").required().label("To Date"),

    fromDate: Joi.string().invalid("").required().label("From Date"),

    collectionTypeID: Joi.number().allow("", null).label("Collection type"),
        
}